import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreatePersonalTrainingSubscriptionService=async(data)=>{
    try {
        const result = await publicPost(`api/personal_training_subscription/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdatePersonalTrainingSubscriptionService=async(data,id)=>{
    try {
        const result = await put(`api/personal_training_subscription/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetPersonalTrainingSubscriptionService=async()=>{
    try {
        const result = await get(`api/personal_training_subscription/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeletePersonalTrainingSubscriptionService=async(id)=>{
    try {
        const result = await deleteRequest(`api/personal_training_subscription/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

